<template>
  <div
    :class="{
      pastel1: filterOn == 'Bouwkunde',
      pastel2: filterOn == 'Werktuigbouwkunde',
      pastel3: filterOn == 'Installatietechniek',
      pastel4: filterOn == 'Elektrotechniek',
      pastel5: filterOn == 'Huisvesting',
      pastel6: filterOn == 'Plattegronden',
      pastel7: filterOn == 'Concepten - 3D Print',
      pastel8: filterOn == 'Brandpreventie'
    }"
    class="discipline"
  >
    <select v-model="searchfieldValue" @change="$emit('update', searchfieldValuee)" id="cars">
      <option value="">Filter</option>

      <option value="Bouwkunde">Bouwkunde</option>
      <option value="Werktuigbouwkunde">Werktuigbouwkunde</option>
      <option value="Installatietechniek">Installatietechniek</option>
      <option value="Elektrotechniek">Elektrotechniek</option>
      <option value="Brandpreventie">Brandpreventie</option>
      <option value="Huisvesting">Huisvesting</option>
      <option value="Plattegronden">Plattegronden</option>
      <option value="Concepten - 3D Print">Concepten - 3D Print</option>
      <option value="Nen2580">Nen2580</option>
    </select>
  </div>
</template>

<script>
import store from '../../../store';

export default {
  name: 'DropdownSelect2',
  props: {
    filterOn: String,
    filterBy: String
  },
  data() {
    return {
      searchfieldValuee: ''
    };
  },
  computed: {
    tekFilters() {
      return store.state.opdrFilters;
    },
    opdrFilters() {
      return store.state.opdrFilters;
    },
    searchfieldValue: {
      get() {
        return this.filterOn;
      },
      set(val) {
        this.searchfieldValuee = val;
        if (this.filterBy == 'disciplines') {
          this.opdrFilters.disciplines = val;
          store.commit('updateOpdrFilters', this.opdrFilters);
        }
      }
    },
    isSearchfieldActive() {
      if (this.searchfieldValue != '') {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    emitUpdate() {
      // $emit('tingtong', $event, 1, 2, 3, 4, "cupcakes")
      //this.filterOn =
      //store.state.tekFilters.name = this.searchfieldValuee
    },
    resetSearchfieldValue() {
      this.searchfieldValue = '';
      //this.emitUpdate()
    }
  }
};
</script>

<style scoped>
#cars {
  cursor: pointer;
  font-weight: 500;
  border: none;
  -webkit-appearance: none;
  background: none;
  color: #fff;
  font-size: 14px;
  /* width: inherit; */
  font-family: poppins;
  text-align: center;
}

.searchfieldholder {
  position: relative;
  /* padding-right: 10px; */
}
.searchfield {
  /* max-width: 200px; */
  /* width: 100%; */
  height: 40px;
  background-color: #e4ecfa;
  border-radius: 100px;
  border: none;
  font-size: 14px;
  padding: 10px 10px 10px 14px;
}

.discipline {
  background-color: #e4ecfa;
  border-radius: 100px;
  padding: 5px 10px;
  display: inline;
  /* text-align: center; */
  /* display: flex;
        align-items: center;
        justify-content: center; */
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-right: 7px;
  /* border: 2px solid white; */
}

.discipline:hover,
#cars:hover {
  background-color: #ffdab5 !important;
}
.discipline:focus {
  background-color: #ffdab5;
}
</style>
